import {rpc} from './session';

export async function getCarriers(meta = {}) {
    return await rpc.request('com.rnis.organizational_units.action.carriers', {}, {meta});
}

export async function getUnit(inn, ogrn) {
    return await rpc.request('com.rnis.organizational_units.action.unit.get', {inn, ogrn});
}


// WEBPACK FOOTER //
// ./src/helpers/api/organizational_units.js